import { Link } from 'react-router-dom';
import React, { useState} from 'react'

// images
import logo from "../assets/images/logo-circle.png";


export default function ForgotPassword() {

  const [email, setEmail] = useState('');
  const [flag, setFlag] = useState('');
  const [error, setError] = useState('');

  const handleChangeEmail = (e) => {
    const value = e.target.value;
    setEmail(value);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/forgot_password`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        email: email
      })
    })
    .then(r => r.json())
    .then(response => {
      if(response.success){
        console.log("Response back is == ", response);
        setFlag(response.message);
      } else {
        setError(response.message);
      }
    });

  }

  return (
    <>
        {/* <!-- login START --> */}
        <div className="bds-loginconatiner">
            <div className="bds-popupcontainer">
                <div className="bds-login_title bds-login-titlev2">
                    <Link to="/">
                      <img src={logo}alt="3bids logo" className='site-logo' width={150} height={150}   />
                    </Link>
                    <h5>Password Lost? we’ll send you the password reset link</h5>
                </div>
                <div className="bds-login-content bds-popup-content">
                    <form className="bds-themeform" onSubmit={(e) => handleSubmit(e)}>
                        <fieldset>
                            <div className="bds-themeform__wrap">
                                <div className="form-group">
                                    <div className="bds-placeholderholder">
                                        <input 
                                          type="email"  
                                          className="form-control bds-themeinput" 
                                          required="required" 
                                          onChange={(e) => handleChangeEmail(e)}
                                          placeholder="Enter Email Address"
                                        />
                                    </div>
                                </div>
                                <div className="form-group bds-popup-terms">
                                    <button type="submit" name="submit" className="bds-btn-solid-lg">Send reset link<i className="icon-arrow-right"></i></button>
                                </div>
                                {error && <p className='text-danger text-center w-100'><small>{error}</small></p>}
                                {flag && <p className='text-success text-center w-100'><small>{flag}</small></p>}
                                <div className="form-group bds-lost-password">
                                    <Link to="/signup">
                                      Join us today
                                    </Link>
                                    <Link to="/signin">
                                      Sign In
                                    </Link>
                                    
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
        {/* <!-- login START --> */}
    </>
  )
}
